/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Box, BoxProps } from "@mui/material";
import { mergeSx } from "@/src/utils/mergeSx";

type LogoBirdProps = BoxProps;

export default function LogoBird({ sx, ...boxProps }: LogoBirdProps) {
  return (
    <Box
      component={"svg"}
      width="586"
      height="790"
      viewBox="0 0 586 790"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      sx={mergeSx((theme) => ({ color: theme.palette.common.white }), sx)}
      {...boxProps}
    >
      <path
        d="M91.5097 498.427C66.103 473.809 44.1708 469.087 44.1708 469.087C74.68 537.629 136.872 596.987 172.944 622.189C172.944 622.189 100.694 528.675 190.588 353.1C204.922 319.35 231.308 278.462 205.3 244.022C198.363 234.838 191.007 228.04 181.834 222.699C165.052 214.523 146.34 207.148 128.142 197.916C41.9056 154.198 15.2837 99.6621 8.96597 58.915C8.7654 57.9128 8.71231 56.946 8.57664 56.1914C14.9003 131.054 38.3131 167.315 111.914 232.845C149.296 266.129 159.489 304.842 142.506 356.018C142.665 340.378 143.756 302.596 97.6386 257.976C29.4234 191.98 0.099879 138.057 0.099879 138.057C-2.57234 216.492 48.9371 253.637 87.227 300.156C121.889 342.27 124.148 359.862 123.323 402.625C115.99 378.201 99.9392 360.251 73.8542 332.013C33.6294 288.471 3.8221 244.918 3.8221 244.918C6.27605 307.666 33.6648 329.384 75.8893 379.557C96.6181 404.187 113.949 429.819 114.751 462.873C105.313 444.787 96.04 431.93 69.6836 408.272C40.9323 382.463 20.3155 355.623 20.3155 355.623C25.247 400.668 35.346 411.114 77.2519 454.956C120.751 500.466 121.429 509.975 127.635 542.905C119.417 529.246 110.256 516.572 91.5273 498.427H91.5097Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.5423 0C104.518 182.755 338.164 128.555 312.922 289.981C296.836 392.851 264.055 499.307 264.078 546.71C264.079 642.593 380.046 666.633 474.482 642.593C554.676 622.176 562.497 673.944 562.518 674.084L562.524 674.072L562.96 674.043C594.731 689.099 587.335 721.057 577.82 734.887C572.487 718.463 558.966 702.499 532.557 702.617C496.314 702.782 427.88 720.674 277.894 744.467C72.2105 777.09 45.6058 789.547 45.6058 789.547C45.476 775.428 60.5841 760.513 81.2952 748.581C115.521 728.874 171.331 705.175 276.496 677.598H276.992C205.65 659.252 194.017 604.74 190.478 561.157C188.23 533.444 192.868 460.339 228.851 355.158C268.032 240.645 194.572 231.696 127.938 197.911C-30.8078 117.429 12.4359 0.287383 12.5423 0ZM532.42 658.066C522.109 653.739 513.797 656.469 513.797 656.469C521.581 666.959 528.943 668.763 529.004 668.777C537.425 672.388 546.121 670.42 546.164 670.41C538.987 660.229 532.465 658.081 532.42 658.066Z"
        fill="currentColor"
      />
    </Box>
  );
}
